$shm_wordstat_task_list_head $shm_list_head
	title_uri \
	search_showed false
	Title $mol_link
		uri <= title_uri
		title <= title
	add_content /
		<= Add
		<= Sort_menu $mol_pick
			hint \Сортировка задач
			trigger_content /
				<= Menu_trigger_icon $mol_icon_dots_vertical
			bubble_content /
				<= Task_sort $shm_sort
					sort_by? <=> sort_by?
					sort_order? <=> sort_order?
					options *
						created \Дата создания
						updated \Дата редактирования
	Controls $mol_view
		sub <= controls /
	controls /
